<template>
  <v-container
    class="pa-2"
    grid-list-md
    fill-height
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
            md3
          >
            <count-widget 
              color="green"
              icon="mdi-account-tie"
              title="Active Visitors"
              :value="activeVisitors"
              style="max-width: 300px; margin: 0 auto"
              @refresh="doRefresh"
            />
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
          >
            <count-widget 
              color="orange"
              icon="mdi-account-box-multiple"
              title="Total Visitors"
              :value="totalVisitors"
              style="max-width: 300px; margin: 0 auto"
              @refresh="doRefresh"
            />
          </v-flex>
          <v-flex
            xs12
            sm6
            md3
          >
            <count-widget 
              color="red"
              icon="person"
              title="Expected Visitors"
              :value="$store.state.expectedVisitors"
              style="max-width: 300px; margin: 0 auto"
              @refresh="doRefresh"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
            xl3
          >
            <feeds />
          </v-flex>
          <v-flex
            xs12
            sm6
          >
            <tickets />
          </v-flex>
          <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :timeout="0"
            bottom
          >
            {{ snackbarMessage }}
            <v-btn
              flat
              @click.native="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CountWidget from '@/components/common/CountWidget';
import Feeds from '@/components/max-admin/dashboard/Feeds';
import Tickets from '@/components/max-admin/dashboard/Tickets';

import _toArray from '@/mixins/util-mixin';

export default {
  name: 'Dashboard',
  components: {
    'count-widget': CountWidget,
    tickets: Tickets,
    feeds: Feeds
  },
  mixins: [_toArray],
  data() {
    return {
      visitorLog: [],
      expectedVis: [],
      totalUsers: 0,
      activeUsers: 0,
      snackbar: false,
      snackbarMessage: '',
      snackColor: 'primary'
    };
  },
  computed: {
    activeVisitors() {
      return this.$store.state.visitorLogs.filter(o => !o.checkOutDate).length;
    },
    totalVisitors() {
      return this.$store.state.visitorLogs.length;
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Dashboard' });
  },
  methods: {
    doRefresh(title) {
      switch (title) {
        case 'Active Visitors':
          this.$store.dispatch('getVisitorLog');

          break;

        case 'Total Visitors':
          this.$store.dispatch('getVisitorLog');
          break;

        case 'Expected Visitors':
          this.$store.dispatch('getExpectedVisitors');
          break;
        default:
          break;
      }
    }
  }
};
</script>
